"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { ActionModel } from './models/ActionModel.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { dynamic } from '../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { ActionContextProvider } from './context.mjs';
import { useActionStateContext } from './models/ActionStateContext.mjs';
import { useConfirmationModalButtonSlot } from './hooks/useConfirmationModalButtonSlot.mjs';
import { useActionButtonState } from './hooks/useActionButtonState.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const actionButtonContext = {
  onPress: dynamic((props) => {
    const action = ActionModel.use();
    const confirmAction = ActionModel.useConfirmationAction();
    const isConfirmationButton = useConfirmationModalButtonSlot(props) === "primary";
    const isAbortButton = useConfirmationModalButtonSlot(props) === "abort";
    if (isAbortButton) {
      return action.confirmationModalController.close;
    }
    return isConfirmationButton ? confirmAction.execute : action.execute;
  }),
  isPending: dynamic((props) => useActionButtonState(props) === "isPending"),
  isSucceeded: dynamic(
    (props) => useActionButtonState(props) === "isSucceeded"
  ),
  isFailed: dynamic((props) => useActionButtonState(props) === "isFailed"),
  "aria-disabled": dynamic((props) => {
    const state = useActionButtonState(props);
    const someActionInContextIsBusy = useActionStateContext().useIsBusy();
    return state === "isExecuting" || someActionInContextIsBusy;
  })
};
const Action = flowComponent("Action", (props) => {
  const { children, actionModel: actionModelFromProps, ...actionProps } = props;
  const newActionModel = ActionModel.useNew(actionProps);
  const actionModel = actionModelFromProps ?? newActionModel;
  const propsContext = {
    Button: actionButtonContext,
    Link: {
      onPress: dynamic(() => ActionModel.use().execute)
    },
    MenuItem: {
      onAction: dynamic(() => ActionModel.use().execute)
    },
    Modal: {
      slot: dynamic((props2) => {
        const { slot } = props2;
        const action = ActionModel.use();
        action.needsConfirmation = slot === "actionConfirm";
        return slot;
      }),
      isDismissable: dynamic((props2) => {
        const action = ActionModel.use();
        const actionState = action.state.useValue();
        return actionState === "isExecuting" || actionState === "isPending" ? false : props2.isDismissable;
      }),
      controller: dynamic(() => {
        const action = ActionModel.use();
        return action.needsConfirmation ? action.confirmationModalController : action.getOverlayController("Modal");
      }),
      ActionGroup: {
        Button: actionButtonContext
      }
    }
  };
  return /* @__PURE__ */ jsx(ActionContextProvider, { value: actionModel, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children }) });
});

export { Action, Action as default };
//# sourceMappingURL=Action.mjs.map
